import React, { useState, useEffect, useContext } from 'react';
import { Context } from '../contexts/AuthContext';

const Login = () => {
  const loggerUserData = JSON.parse(localStorage.getItem('@director/usr'));
  const { authState, handleLogin } = useContext(Context);
  const [state, setState] = useState({ dominio: '', login: '', password: '', error: '' });

  const handleChange = ({ target }) => {
    const { name, value } = target;
    setState(_state => ({ ..._state, [name]: value }));
  }

  useEffect(() => {
    if (loggerUserData) {
      window.location.href = '/';
    }
  });

  const submit = async e => {
    e.preventDefault();

    let token = btoa(`${state.dominio}|${state.login}:${state.password}`);
    const response = await handleLogin(token);

    if (!response.sucesso)
      setState(_state => ({ ..._state, error: 'Usuário ou senha inválidos.' }));
  }

  return (
    <div className="d-flex justify-content-center align-items-center login">
      <div className="shadow-lg">
        <div className="card-body bg-white">
          <h5 className="card-title">Login</h5>
          <form onSubmit={submit} className="mt-2">
            <label>Domínio:</label>
            <input name="dominio" className="form-control" value={state.dominio} onChange={handleChange} />
            <label>Email:</label>
            <input name="login" className="form-control" value={state.login} onChange={handleChange} />
            <label>Senha:</label>
            <input name="password" type="password" className="form-control" value={state.password} onChange={handleChange} />
            <div className="d-grid gap-2 mt-3">
              <button className="btn btn-primary" type="submit" onClick={submit}>Entrar</button>
              <p className="text-danger">{state.error}</p>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Login;